import type { Theme } from '../../types/theme';

export const mintlifyTheme: Theme = {
  id: 'mintlify',
  name: 'Mintlify',
  description: 'Dark documentation platform with green accents and clean typography',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/mintlify/DESIGN.md',
  visualKeywords: ['dark', 'green accent', 'documentation', 'clean', 'readable'],
  colors: {
    background: '#0a0a0a',
    surface: '#171717',
    surfaceElevated: '#212121',
    textPrimary: '#ffffff',
    textSecondary: '#a1a1aa',
    textMuted: '#a1a1aa',
    border: '#27272a',
    borderSubtle: '#313134',
    primary: '#10b981',
    primaryHover: '#1fc890',
    primaryActive: '#009b63',
    accent: '#10b981',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'low',
    tone: 'readable',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
